var _circle, _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLedBusinessDetails(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 83,
    height: 83,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 41.5,
    r: 41.5,
    fill: "#6C5AFC",
    fillOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.438 57.313H23.562v-8.559A9.098 9.098 0 0121 46.922v10.39a2.563 2.563 0 002.563 2.563h35.874A2.563 2.563 0 0062 57.313V46.922a8.635 8.635 0 01-2.563 1.82v8.57z",
    fill: "#6C5AFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.469 50.138a1.28 1.28 0 001.281-1.282v-6.995h-2.563v2.64H36.376v2.562h12.813v1.793a1.28 1.28 0 001.28 1.282z",
    fill: "#6C5AFC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.719 29.125H49.187V27.05A3.1 3.1 0 0046.048 24h-9.096a3.101 3.101 0 00-3.14 3.05v2.075h-11.53A1.281 1.281 0 0021 30.407v10.25a6.406 6.406 0 006.406 6.406h3.844v1.793a1.281 1.281 0 002.563 0v-6.995H31.25v2.64h-3.844a3.844 3.844 0 01-3.843-3.844v-8.97h35.874v8.97a3.844 3.844 0 01-3.843 3.843h-1.282v2.563h1.282A6.406 6.406 0 0062 40.656v-10.25a1.281 1.281 0 00-1.281-1.28zm-14.094 0h-10.25v-2.011a.577.577 0 01.577-.551h9.11a.552.552 0 01.563.538v2.024z",
    fill: "#6C5AFC"
  })));
}

export default SvgLedBusinessDetails;